import React from "react";

import { useNavigate } from "react-router-dom";
import { ROUTES } from "src/routes";

export const BackToSignInButton = () => {
  const navigate = useNavigate();
  return (
    <button
      className="amplify-button amplify-field-group__control amplify-button--link amplify-button--small customized-back-to-signin-button"
      onClick={() => navigate(ROUTES.ExternalSignIn.path)}
    >
      Back to sign In
    </button>
  );
};
